import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import {Card, Grid, Input, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {downloadFile} from '../../../common/util/file';
import {paths} from '../../../common/dictionaries/urls';
import {
  dateFormatPicker,
  noTimeZoneShortISODate,
} from '../../../common/constants/datesFormat';
import {Actions} from '../../../common/actions';
import LogisticIndicesResults from './results';
import './logisticIndices.scss';

class LogisticsIndicesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'startDate': moment().format(noTimeZoneShortISODate),
      'endDate': moment().format(noTimeZoneShortISODate),
      'name': '',
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.LogisticIndicesReport, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  componentDidUpdate() {
    const {excelFileURL} = this.props;

    if (excelFileURL) {
      downloadFile(excelFileURL);
      this.props.clearLogisticIndicesDetailExcel();
    }
  }

  componentWillUnmount() {
    this.props.clearLogisticIndices();
  }

  handleSearchClick = () => {
    const {startDate, endDate} = this.state;
    const params = {startDate, endDate};
    this.props.fetchLogisticIndices(params);
  };

  handleExportClick = () => {
    const {name, startDate, endDate} = this.state;
    const params = {name, startDate, endDate};
    this.props.downloadLogisticDetailExcel(params);
  };

  changeDetailName = (name) => {
    this.setState({name});
  };

  changeStartDate = (date) => {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    const {startDate, endDate} = this.state;

    if (dateFormatted !== startDate) {
      const newState = {'startDate': dateFormatted};

      if (!endDate || (endDate && moment(date) > moment(endDate))) {
        newState.endDate = dateFormatted;
      }

      this.setState(newState);
    }
  };

  changeEndDate = (date) => {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    if (dateFormatted !== this.state.endDate) {
      this.setState({'endDate': dateFormatted});
    }
  };

  renderFilterDates = () => {
    const {loading, downloadingExcel, loadingDetail, detail} = this.props;
    const {startDate, endDate, name} = this.state;

    return (
      <Grid textAlign='left'>
        <Grid.Row>
          <Grid.Column width={2} className='label'>
            <h4>Fecha Inicio</h4>
          </Grid.Column>
          <Grid.Column width={3}>
            <DatePicker
              customInput={<Input icon='calendar' size='small' />}
              dateFormat={dateFormatPicker}
              selected={
                startDate ?
                  moment(startDate, noTimeZoneShortISODate).toDate() :
                  null
              }
              onChange={this.changeStartDate}
              locale='es'
              placeholderText='Fecha Inicio'
              disabled={loading}
            />
          </Grid.Column>
          <Grid.Column width={2} className='label'>
            <h4>Fecha Fin</h4>
          </Grid.Column>
          <Grid.Column width={3}>
            <DatePicker
              customInput={<Input icon='calendar' size='small' />}
              dateFormat={dateFormatPicker}
              selected={
                endDate ?
                  moment(endDate, noTimeZoneShortISODate).toDate() :
                  null
              }
              onChange={this.changeEndDate}
              minDate={moment(startDate).toDate()}
              placeholderText='Fecha Fin'
              disabled={loading}
              locale='es'
            />
          </Grid.Column>
          <Grid.Column width={1} />
          <Grid.Column width={2} textAlign='right'>
            <Button primary disabled={loading} onClick={this.handleSearchClick}>
              BUSCAR
            </Button>
          </Grid.Column>
          <Grid.Column width={3} textAlign='right'>
            <Button
              primary
              icon='download'
              content='EXPORTAR DETALLE'
              loading={downloadingExcel}
              disabled={!name || loadingDetail || !detail.length}
              onClick={this.handleExportClick}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  render() {
    const {list, loading, detail, loadingDetail} = this.props;
    const {startDate, endDate, name} = this.state;

    return (
      <div className='logistic-indices-report'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Índices de Logística</h2>
            </div>
            <div className='filters-section'>{this.renderFilterDates()}</div>
          </div>
        </Card>

        <LogisticIndicesResults
          logisticIndicesList={list}
          loading={loading}
          detail={detail}
          loadingDetail={loadingDetail}
          startDate={startDate}
          endDate={endDate}
          detailName={name}
          changeDetailName={this.changeDetailName}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.logisticIndices.loading,
    'list': state.logisticIndices.list,
    'loadingDetail': state.logisticIndices.loadingDetail,
    'detail': state.logisticIndices.detail,
    'downloadingExcel': state.logisticIndices.downloadingExcel,
    'excelFileURL': state.logisticIndices.excelFileURL,
    'permissions': state.session.permissions,
  };
};


const {
  navigateTo,
  clearLogisticIndices,
  fetchLogisticIndices,
  downloadLogisticDetailExcel,
  clearLogisticIndicesDetailExcel,
} = Actions;


export default connect(mapStateToProps, {
  navigateTo,
  clearLogisticIndices,
  fetchLogisticIndices,
  downloadLogisticDetailExcel,
  clearLogisticIndicesDetailExcel,
})(LogisticsIndicesReport);
